import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import sendUsAMessageAction from "cc-frontend/lib/actions/app-state/KB_SEND_US_A_MESSAGE"
import type Dispatcher from "cc-frontend/services/dispatcher"

interface Signature {
  Element: HTMLDivElement
  Args: {}
}

export default class KbSearchAfterOptions extends Component<Signature> {
  @service declare dispatcher: Dispatcher

  @action
  contactUs() {
    let preparedAction = sendUsAMessageAction({
      searchQuery: false,
      locationOfAction: "search_box",
    })
    this.dispatcher.dispatchPreparedAction(preparedAction)

    if (window && window.Intercom) {
      window.Intercom("showNewMessage")
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Search::AfterOptions": typeof KbSearchAfterOptions
  }
}
